import React from "reactn";
import { BoxForm } from "../../../../../components/UI/form";
import { Icon } from "semantic-ui-react";

class Schedule extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = (e, v) => {
    this.props.onAutomationChange({ [e]: v });
  };

  getMaxValue = (timingUnit) => {
    switch(timingUnit) {
      case 'Hours': return 12;
      case 'Days': return 6;
      case 'Weeks': return 3;
      case 'Months': return 11;
      default: return 12;
    }
  };

  getAvailableTimeUnits = () => {
    const { automation } = this.props;
    const baseUnits = ['Hours', 'Days', 'Weeks'];
    
    if (automation.automationType === 'milestone') {
      return [...baseUnits, 'Months'];
    }
    
    return baseUnits;
  };

  getScheduleDescription = () => {
    const { automation } = this.props;
    if (!automation.timing || !automation.timingUnit || !automation.automationType) {
      return "";
    }

    const timingText = `${automation.timing} ${automation.timingUnit}`;

    if (automation.automationType === "auto-payment-reminder") {
      return `Your auto-payment reminder will be sent ${timingText} before the due date`;
    }

    const beforeAfter = automation.automationType === "reminder" || automation.automationType === "enrollment-reminder"? "before" : "after";
    const eventType = automation.automationType === "follow-up"? "end date" :
    automation.automationType === "enrollment-confirmation" || automation.automationType === "enrollment-reminder" ? "enrollment date" : "start date";

    return `Your automation is scheduled for ${timingText} ${beforeAfter} the ${eventType}`;
  };

  customForm = () => {
    const { automation } = this.props;
    const maxValue = this.getMaxValue(automation.timingUnit);
    const availableTimeUnits = this.getAvailableTimeUnits();

    return (
      <div className="formbody" style={{ 
        padding: '0',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(75, 75, 75, 0.6)',
        border: '1px solid rgb(190, 190, 190)',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        width: '100%',
        maxWidth: '800px', 
        margin: '0 auto'
      }}>
        {/*card header*/}
        <div style={{
          padding: '8px 8px',
          borderBottom: '1px solid #e6f0ff',
          backgroundColor: '#f8fbff', 
          textAlign: 'center'
        }}>
          <h2 style={{
            margin: 0,
            fontSize: window.innerWidth < 768 ? '1.4rem' : '1.75rem',
            color: '#1a56db',
            fontWeight: window.innerWidth < 768 ? '600' : '700',
            letterSpacing: '-0.025em'
          }}>
            Schedule Automation
          </h2>
        </div>

        {/*body*/}
        <div style={{ 
          padding: window.innerWidth < 768 ? '15px' : '20px',
          backgroundColor: 'white'
        }}>
          <form>
            <div style={{ maxWidth: '700px', margin: '0 auto' }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center',
                marginBottom: '24px',
                gap: window.innerWidth < 768 ? '8px' : '24px',
                padding: window.innerWidth < 768 ? '12px' : '20px',
                backgroundColor: 'rgb(255, 255, 255)',
                borderRadius: '12px',
                border: '2px solid rgb(230, 230, 230)',
              }}>
                <label style={{ 
                  minWidth: window.innerWidth < 768 ? '60px' : '180px',
                  fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                  color: '#1f2937',
                  fontWeight: '600'
                }}>
                  Timing<span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>
                </label>
                <Icon 
                  name='info circle' 
                  style={{ 
                    color: 'rgb(0, 0, 0)',
                    marginRight: '-8px',
                    marginBottom: '10px',
                    fontSize: window.innerWidth < 768 ? '0.9rem' : '1.3rem',
                  }}
                  title="Set the timing for your automation"
                />
                <div style={{ 
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: window.innerWidth < 768 ? '6px' : '8px'
                }}>
                  <input
                    type="range"
                    className="input-fields"
                    style={{ 
                      width: '100%',
                      height: window.innerWidth < 768 ? '6px' : '8px',
                      borderRadius: '4px',
                      background: 'rgb(233, 233, 233)',
                      color: '#1a56db',
                      outline: 'none',
                      cursor: automation.templateId ? 'pointer' : 'not-allowed',
                      opacity: automation.templateId ? 1 : 0.6
                    }}
                    value={automation?.timing || 1}
                    name="timing"
                    min="1"
                    max={maxValue}
                    step="1"
                    onChange={e => this.handleChange(e.target.name, parseInt(e.target.value))}
                    disabled={!automation.templateId}
                  />
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: window.innerWidth < 768 ? '0.8rem' : '0.9rem',
                    color: '#666'
                  }}>
                    <span>1</span>
                    <span style={{ fontWeight: 'bold', color: '#1a56db' }}>
                      {automation?.timing || 1}
                    </span>
                    <span>{maxValue}</span>
                  </div>
                </div>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center',
                marginBottom: '24px',
                gap: window.innerWidth < 768 ? '8px' : '24px',
                padding: window.innerWidth < 768 ? '12px' : '20px',
                backgroundColor: 'rgb(255, 255, 255)',
                borderRadius: '12px',
                border: '2px solid rgb(230, 230, 230)',
              }}>
                <label style={{ 
                  minWidth: window.innerWidth < 768 ? '60px' : '180px',
                  fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                  color: '#1f2937',
                  fontWeight: '600'
                }}>
                  Time Unit<span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>
                </label>
                <Icon 
                  name='info circle' 
                  style={{ 
                    color: 'rgb(0, 0, 0)',
                    marginRight: '-8px',
                    marginBottom: '10px',
                    fontSize: window.innerWidth < 768 ? '0.9rem' : '1.3rem',
                  }}
                  title="Select the time unit for your automation"
                />
                <div style={{ 
                  flex: 1,
                  display: 'flex',
                  gap: window.innerWidth < 768 ? '8px' : '12px'
                }}>
                  {availableTimeUnits.map(unit => (
                    <div
                      key={unit}
                      onClick={() => {
                        if (automation.templateId) {
                          this.handleChange('timingUnit', unit);
                          this.handleChange('timing', 1);
                        }
                      }}
                      style={{
                        flex: 1,
                        padding: window.innerWidth < 768 ? '12px 8px' : '16px',
                        borderRadius: '8px',
                        border: '2px solid',
                        borderColor: automation.timingUnit === unit ? '#1a56db' : '#e6f0ff',
                        backgroundColor: automation.timingUnit === unit ? '#f8fbff' : 'rgb(233, 233, 233)',
                        cursor: automation.templateId ? 'pointer' : 'not-allowed',
                        transition: 'all 0.2s ease',
                        textAlign: 'center',
                        fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                        fontWeight: automation.timingUnit === unit ? '600' : '500',
                        color: automation.timingUnit === unit ? '#1a56db' : '#666',
                        opacity: automation.templateId ? 1 : 0.6, 
                        minWidth: 0,
                        maxWidth: '100%',
                        width: '100%'
                      }}
                    >
                      {unit}
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ 
                padding: window.innerWidth < 768 ? '15px' : '20px',
                backgroundColor: 'rgb(248, 248, 248)',
                borderRadius: '12px',
                border: '2px solid rgb(230, 230, 230)',
                textAlign: 'center'
              }}>
                <div style={{ 
                  fontSize: window.innerWidth < 768 ? '0.9rem' : '1.1rem',
                  color: '#666',
                  fontStyle: 'italic',
                  minHeight: window.innerWidth < 768 ? '40px' : '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {this.getScheduleDescription() || "Complete the timing fields above to see your schedule summary"}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };

  render() {
    return (
      <BoxForm
        handleChange={this.handleChange}
        name={""}
        customForm={this.customForm()}
      />
    );
  }
}

export default Schedule;